<template>
  <Dialog
    :visible="visible"
    :title="$t(`${namespace}.title`)"
    :isLoading="isLoading"
    max-width="638"
    @close="close()"
  >
    <div v-if="visible">
      <form novalidate @submit.prevent="deleteEmployees">
        <v-card-text class="dialog__body pb-0">
          <FormTextarea
            v-model="form.ids"
            :label="$t(`${namespace}.form.fieldIDsLabel`)"
            :name="$t(`${namespace}.form.fieldIDsName`)"
            :placeholder="$t(`${namespace}.form.fieldIDsPlaceholder`)"
            :disabled="isLoading"
            :v-validate="{ required: true }"
            ref="ids"
            @blur="normalizeIDs"
          />
        </v-card-text>

        <v-divider />

        <v-card-actions class="dialog__footer">
          <v-spacer />

          <a
            v-if="!isLoading"
            class="mr-4"
            @click.prevent="close()"
          >
            {{ $t(`${namespace}.form.cancel`) }}
          </a>

          <Button
            type="submit"
            :loading="isLoading"
            :disabled="isLoading"
          >
            {{ $t(`${namespace}.form.submitButton`) }}
          </Button>
        </v-card-actions>
      </form>
    </div>
  </Dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ExcludeEmployeesByIDDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      selectedCompany: ({ company }) => company.selectedCompany
    })
  },
  data () {
    return {
      namespace: 'Components.DeleteEmployeesDialog',
      isLoading: false,
      form: {
        ids: ''
      }
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    close (reload = false) {
      this.$emit('close', reload)
    },

    setLoadingValue (boolean) {
      this.isLoading = boolean
    },

    normalizeIDs () {
      if (this.form.ids.trim().length) {
        this.form.ids = this.form.ids
          .replace(/[^\d,]/g, '')
          .replace(/,+/g, ',')
      }
    },

    forceFieldValidation (ref, selector) {
      const $field = this.$refs[ref]?.$el

      if ($field) {
        $field.querySelector(selector).focus()
        $field.querySelector(selector).blur()
      }
    },

    resetAllFields () {
      this.form.ids = ''
    },

    async deleteEmployees () {
      const isValid = await this.$validator.validateAll()

      if (!isValid || !this.form.ids.trim().length) {
        this.forceFieldValidation('ids', 'textarea')
        return
      }

      this.setLoadingValue(true)

      try {
        const companyId = this.selectedCompany.id
        const ids = this.form.ids
          .split(',')
          .filter(id => Boolean(id))
          .map(id => Number(id))

        await this.$apiService.employee.multiDeleteById(companyId, { ids })

        this.close(true)
        this.showAlert({
          type: 'success',
          message: this.$t(`${this.namespace}.success`)
        })
      } catch (error) {
        const employeeIDsWithError = error && error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors
          : []
        const message = error && error.response && error.response.data && error.response.data.data
          ? this.$t(`${this.namespace}.error`).replace('[VAL]', employeeIDsWithError.join(', '))
          : this.$t('Common.genericError')

        this.showAlert({
          type: 'error',
          message,
          timeout: 8000
        })
      }

      this.setLoadingValue(false)
    }
  },
  watch: {
    visible (val) {
      // fix validation error when close dialog
      this.$validator._paused = !val

      this.resetAllFields()
      this.setLoadingValue(false)

      val && this.$ga.page('/dialog/colaboradores/excluir-em-massa-por-id')
    }
  }
}
</script>
